import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingProvider } from '@app/components/_shared/loading-spinner/loading-spinner.component';
import { UserModel } from '@app/models/user/user.model';
import { AuthService } from '@app/services/auth.service';
import { LocalisationService } from '@app/services/localisation.service';
import { QuestionnaireService } from '@app/services/questionnaire.service';
import { UserService } from '@app/services/user.service';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit, OnDestroy {
  static route: string = 'welcome';

  locale: any = {};

  firstTime: boolean;
  currentUser: UserModel = new UserModel();
  questionsRemaining: number;
  multiQuestionsRemaining: number;
  questionnaireStatus: number;

  subscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private questionnaireService: QuestionnaireService,
    private spinner: LoadingProvider,
    private localisation: LocalisationService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('WelcomeComponent');
    this.spinner.show(this.locale.findingYourAccount);

    this.subscription = Observable.forkJoin(
      this.userService.getUser(),
      this.questionnaireService.getCurrentQuestionnaire()
    )
      .finally(() => {
        this.spinner.hide();
      })
      .subscribe(
        result => {
          const user = result[0];
          const questionnaire = result[1];
          this.questionsRemaining = questionnaire.questions - questionnaire.completed;
          this.multiQuestionsRemaining = questionnaire.multiQuestionsRemaining;

          this.currentUser = user;
          this.firstTime = questionnaire.completed === 0 && questionnaire.firstIncomplete === 1;
          this.questionnaireStatus = questionnaire.status;
        },
        error => {
          // When user has not paid and logging back in again
          if (error.returnCode.errorCode == '11007') {
            this.router.navigate([`/centigrade/payment-request`]);
          }
        }
      );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  goToMain() {
    this.router.navigate([`/centigrade`]);
  }

  goToResults() {
    if (this.questionsRemaining === 0 && this.questionnaireStatus < 100) {
      //Questionnaire complete but not marked as complete so lets mark it as complete
      this.questionnaireService.submitCompleteQuestionnaire().subscribe(result => {
        this.router.navigate([`/centigrade/course-areas`]);
      });
    } else {
      this.router.navigate([`/centigrade/course-areas`]);
    }
  }

  logout() {
    this.authService.logout();
    this.goToMain();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/welcome/welcome.component.ts